module.exports = __webpack_public_path__ + "img/apache.3538b61c.svg";